import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const EditInternshipPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/EditInternshipPageContainer" */
      './EditInternshipPageContainer'
    ).then((module) => ({ default: module.EditInternshipPageContainer })),
});
